import FieldTypesEnum from '../Enums/FieldTypesEnum';
import statusHelper from '../Helpers/statusHelper';
import stringHelper from '../Helpers/stringHelper';
import dateTimeHelper from '../Helpers/datetimeHelper';
import React from 'react';

export default class PlanningDetailSnapshotItem {
  constructor(item) {
    this.PlanningDetailId = item.planningDetailId;
    this.SnapshotDateUtc = item.snapshotDateUtc;
    this.NumberOfPlannedAssignments = item.numberOfPlannedAssignments;
    this.StartDate = item.startDate;
    this.EndDate = item.endDate;
    this.Status = item.status;
    this.StatusCompleted = item.statusCompleted;
    this.NumberOfContractedAssignmentsOverride = item.numberOfContractedAssignmentsOverride;
    this.TargetAssignmentRate1 = item.targetAssignmentRate1;
    this.TargetAssignmentRate2 = item.targetAssignmentRate2;
    this.TargetAssignmentRate3 = item.targetAssignmentRate3;
    this.TargetAssignmentRate4 = item.targetAssignmentRate4;
    this.TargetCompletionRate1 = item.targetCompletionRate1;
    this.TargetCompletionRate2 = item.targetCompletionRate2;
    this.TargetCompletionRate3 = item.targetCompletionRate3;
    this.TargetCompletionRate4 = item.targetCompletionRate4;
  }

  static NameOfTheIdField() {
    return 'PlanningDetailId';
  }

  static nameOfTheItemDetailList() {
    return 'Planning Detail Snapshot';
  }

  static DateFields = ['SnapshotDateUtc', 'StartDate', 'EndDate'];
  static DateOnlyFields = ['StartDate', 'EndDate'];
  static BoolFields = ['StatusCompleted'];
  static MoneyFields = [];
  static MoneyFieldsSecondary = [];

  static Currency() {
    return '';
  }

  static CurrencySecondary() {
    return '';
  }

  static getStatusCellContent(item) {
    if (!item.Status) return null;
    return (
      <span>
        {statusHelper.getStatusColorIcon(item.Status)}
        {stringHelper.convertToWords(item.Status)}
      </span>
    );
  }

  static getSnapshotDateCellContent(item) {
    return dateTimeHelper.toYYYYsMMsDDsHHsMM(item.SnapshotDateUtc);
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Planning Detail Id',
        orderById: 'PlanningDetailId',
        data: 'PlanningDetailId',
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: 'Snapshot Date (UTC)',
        orderById: 'SnapshotDateUtc',
        data: PlanningDetailSnapshotItem.getSnapshotDateCellContent,
      },
      { label: 'Volume', orderById: 'NumberOfPlannedAssignments', data: 'NumberOfPlannedAssignments' },
      { label: 'Start Date', orderById: 'StartDate', data: 'StartDate' },
      { label: 'End Date', orderById: 'EndDate', data: 'EndDate' },
      { label: 'Status', orderById: 'Status', data: PlanningDetailSnapshotItem.getStatusCellContent },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'PlanningDetailId', label: 'Planning Detail Id' },
        { name: 'SnapshotDateUtc', label: 'Snapshot Date (UTC)' },
        { name: 'Status', label: 'Status' },
        { name: 'StatusCompleted', label: 'Completed' },
        { name: 'NumberOfPlannedAssignments', label: 'Volume' },
        { name: 'StartDate', label: 'Start Date' },
        { name: 'EndDate', label: 'End Date' },
        { name: 'NumberOfContractedAssignmentsOverride', label: 'Contracted Override' },
      ],
    },
    {
      tabName: 'TargetRates',
      tabLabel: 'Target Rates',
      icon: 'fa-solid fa-bullseye',
      data: [
        { name: 'TargetAssignmentRate1', label: 'Assignment Rate 1' },
        { name: 'TargetAssignmentRate2', label: 'Assignment Rate 2' },
        { name: 'TargetAssignmentRate3', label: 'Assignment Rate 3' },
        { name: 'TargetAssignmentRate4', label: 'Assignment Rate 4' },
        { name: 'TargetCompletionRate1', label: 'Completion Rate 1' },
        { name: 'TargetCompletionRate2', label: 'Completion Rate 2' },
        { name: 'TargetCompletionRate3', label: 'Completion Rate 3' },
        { name: 'TargetCompletionRate4', label: 'Completion Rate 4' },
      ],
    },
  ];
}
